import { useNavigate } from 'react-router-dom'
import { Title, Text, Stack, Card, Group, Button } from '@mantine/core'
import styles from '../_shared/CrudPage.module.css'

/**
 * Step 3 do onboarding (decisão P4 — 2026-05-04):
 * 2 cards equilibrados lado a lado pra escolher caminho de cadastro de
 * equipamentos. Ambos chegam ao mesmo destino (Empresa cliente com
 * áreas + equipamentos vinculados).
 */
export default function OnboardingEquipamentosPage() {
  const navigate = useNavigate()

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <button
            className={styles.backBtn}
            type="button"
            onClick={() => navigate('/onboarding')}
          >
            ← Voltar para o onboarding
          </button>
          <Title order={1} size="h2">
            Cadastre os equipamentos
          </Title>
          <Text c="dimmed" size="sm">
            Escolha o caminho que faz mais sentido pra sua escala atual.
          </Text>
        </div>
      </header>

      <Stack gap="md" mt="lg">
        <Group
          align="stretch"
          gap="md"
          grow
          wrap="nowrap"
          style={{ minHeight: 280 }}
        >
          <Card
            withBorder
            padding="xl"
            radius="md"
            data-testid="onboarding-card-importar"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <div style={{ flex: 1 }}>
              <Text size="3rem" mb="sm" ta="center" aria-hidden="true">
                📊
              </Text>
              <Title order={3} ta="center" mb="xs">
                Importar planilha
              </Title>
              <Text size="sm" c="dimmed" ta="center" mb="md">
                Faz upload de XLSX e o sistema cria áreas + equipamentos
                automaticamente, com preview antes de confirmar.
              </Text>
              <Text size="xs" c="dimmed" ta="center">
                Ideal para: 10+ equipamentos, inventário existente em planilha,
                primeira carga de cliente novo.
              </Text>
            </div>
            <Button
              fullWidth
              mt="lg"
              size="md"
              onClick={() => navigate('/equipamentos/importar')}
              data-testid="cta-importar-planilha"
            >
              Importar planilha →
            </Button>
          </Card>

          <Card
            withBorder
            padding="xl"
            radius="md"
            data-testid="onboarding-card-manual"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <div style={{ flex: 1 }}>
              <Text size="3rem" mb="sm" ta="center" aria-hidden="true">
                📝
              </Text>
              <Title order={3} ta="center" mb="xs">
                Cadastrar manualmente
              </Title>
              <Text size="sm" c="dimmed" ta="center" mb="md">
                Formulário simples: tipo, marca, modelo, capacidade, área. Bom
                pra cadastrar 1 equipamento por vez.
              </Text>
              <Text size="xs" c="dimmed" ta="center">
                Ideal para: 1-10 equipamentos, ajustes pontuais, ambientes
                pequenos (1 sala técnica, 1 escritório).
              </Text>
            </div>
            <Button
              fullWidth
              mt="lg"
              size="md"
              variant="light"
              onClick={() => navigate('/equipamentos/novo')}
              data-testid="cta-cadastrar-manual"
            >
              Cadastrar manualmente →
            </Button>
          </Card>
        </Group>

        <Card
          withBorder
          padding="md"
          radius="md"
          bg="var(--mantine-color-gray-0)"
          mt="md"
        >
          <Text size="sm" c="dimmed">
            <strong>Não sabe qual escolher?</strong> Tem 1-10 equipamentos?
            Cadastre manualmente. Tem 10+ ou já tem inventário em planilha?
            Importe — economiza horas. Os dois caminhos chegam ao mesmo destino:
            equipamentos vinculados à empresa cliente, prontos pra entrar num PMOC.
          </Text>
        </Card>
      </Stack>
    </div>
  )
}
